import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsModule } from '../../modules/material.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { OrgTreeModule } from '../org-tree/org-tree.module';
import { OrgMultiselectionFieldComponent } from './org-multiselection-field/org-multiselection-field.component';
import { OrgMultiselectionMobileComponent } from './org-multiselection-mobile/org-multiselection-mobile.component';
import { DropdownsModule } from '../dropdowns/dropdowns.module';
import { MatDialogModule } from '@angular/material/dialog';
import { OrgMultiselectionComponent } from './org-multiselection/org-multiselection.component';
import { SearchModule } from '../search/search.module';

@NgModule({
  declarations: [OrgMultiselectionFieldComponent, OrgMultiselectionMobileComponent, OrgMultiselectionComponent],
  imports: [CommonModule, FormsModule, MaterialsModule, TranslateModule, OrgTreeModule, DropdownsModule, MatDialogModule, SearchModule],
  exports: [OrgMultiselectionFieldComponent],
})
export class OrgMultiselectionModule {}

export const httpLoaderFactory = (http: HttpClient) => new TranslateHttpLoader(http);
